import React from "react";
import ModalNew from "../../../../../components/ui/popup/Modal";
import {
  PopupContent,
  PopupHeader,
  PopupSection,
} from "../../../../../components/ui/popup/common";

const DemoWelcomeModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalNew className="content-modal" style={{ maxWidth: "480px" }}>
      <PopupHeader
        title="Welcome to Your Demo Filing!"
        setOpenState={onClose}
        icon={`${process.env.PUBLIC_URL}/images/icons/survey_blue_popup.svg`}
        variant="compact"
      />
      <PopupContent>
        <PopupSection>
          This is a demo environment where you can explore the filing process.
          Your assigned tax expert will reach out shortly via the{" "}
          <strong>Messages</strong> tab.
        </PopupSection>
        <PopupSection isLast>
          Feel free to upload sample documents and explore the dashboard to see
          how it works!
        </PopupSection>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "12px",
          }}
        >
          <button className="cta-button primary" onClick={onClose}>
            Filing Dashboard
          </button>
        </div>
      </PopupContent>
    </ModalNew>
  );
};

export default DemoWelcomeModal;
